import { trans } from '../utils';
import ar from './ar';
import en from './en';

const lang = { 'ar': ar, 'en': en };

(function getDynamicTranslations() {
    const facilityLabelEn = localStorage.getItem('facilityLabelEn');
    const facilityLabelAr = localStorage.getItem('facilityLabelAr');
    const array = [
        'FacilityFloor',
        'facilityBuilding',
        'facilityRoom',
        'facilityDepartment',
        'facilityRoomRef',
        'Facility',
        'SiteName',
        'SiteBuilding',
        'SiteDepartment',
        'SiteRoom',
        'SiteWarehouse',
        'Site',
        'Site Type',
        'Facilities',
        'Site Info',
        'facilities',
    ];
    array.forEach((key) => {
        if (lang.en[key]) {
            lang.en[key] = lang.en[key].replace(/(Site|facility)/gi, facilityLabelEn);
        }
        if (lang.ar[key]) {
            lang.ar[key] = lang.ar[key].replace(/(الموقع|المنشأت|المنشأة)/gi, facilityLabelAr);
        }
    });
})();

(function getDynamicTranslations() {
    const isMedicalOnly = localStorage.getItem('MedicalOnly');

    const object = {
        'NonMedicalFacility' :{
            'en':isMedicalOnly == 1 ? "Hospital" : "Non-Medical",
            'ar': isMedicalOnly ==1 ? "مستشفى" : "غير طبي",
        },
        'MedicalFacility' :{
            'en':isMedicalOnly ==1 ? "MT" : "Medical",
            'ar': isMedicalOnly==1 ? "مركز طبي" : "طبي",
        },
    };
    Object.keys(object).forEach((key) => {
            lang.en[key] = object[key].en;
            lang.ar[key] = object[key].ar;
        
    });
})();
export default lang;
    
